import ProductTabs from "./product-tabs";
import initShapes from "./shapes";
import initLetters from "./letters";

if (!customElements.get("product-tabs")) {
    customElements.define("product-tabs", ProductTabs);
}

initShapes();
initLetters();
